export default {
  data() {
    return {
      timer: {
        value: 0,
        ref: null,
      },
    }
  },
  beforeDestroy() {
    this.countdownTimer().stop()
    this.timer = {
      value: 0,
      ref: null,
    }
  },
  computed: {
    hms() {
      const d = Number(this.timer.value)

      if (d) {
        return this.getHmsFromSeconds(d)
      }

      return { h: '00', m: '00', s: '00' }
    },
  },
  methods: {
    nomalize(num) {
      return num.toString().length > 1 ? num : `0${num}`
    },
    getHmsFromSeconds(secs) {
      if (secs) {
        const h = this.nomalize(Math.floor(secs / 3600))
        const m = this.nomalize(Math.floor((secs % 3600) / 60))
        const s = this.nomalize(Math.floor((secs % 3600) % 60))

        return { h, m, s }
      }

      return { h: 0, m: 0, s: 0 }
    },
    countdownTimer() {
      const vm = this

      return {
        countdown() {
          vm.timer.value -= 1

          if (vm.timer.value === 0) vm.countdownTimer().stop()
        },
        start() {
          vm.timer.value = vm.timerCount
          vm.timer.ref = setInterval(this.countdown, 1000)
        },
        stop() {
          clearInterval(vm.timer.ref)
        },
        startFrom(seconds) {
          vm.timer.value = seconds
          vm.timer.ref = setInterval(this.countdown, 1000)
        },
        restart() {
          this.stop()
          this.start()
        },
      }
    },
  },
}
